import React from 'react'

const Banner = () => {
    return (
        <>
            <section className="About_banner_sec">
                <div className="container-fluid p-0">
                    <img className="banner-img" src={process.env.PUBLIC_URL + '/assets/images/find-vendor/banner/banner.png'} />
                    <div className="overlayblack"></div>
                    <div className="overlay-text">
                        <h3 className="banner-title"> Find the Vendor & Location </h3>
                        <h6 className="subtitle"></h6>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner